import type { Screen } from "./types"

import bgImage from "assets/images/ugc_v1/bg.webp"
import coverName from "assets/images/ugc_v1/name-cover.webp"
import coverCountry from "assets/images/ugc_v1/country-cover.webp"
import coverLanguages from "assets/images/ugc_v1/languages-cover.webp"
import coverInstagram from "assets/images/ugc_v1/instagram-cover.webp"
import coverTiktok from "assets/images/ugc_v1/tiktok-cover.webp"
import coverEmail from "assets/images/ugc_v1/email-cover.webp"
import bgImageSuccess from "assets/images/ugc_v1/success-bg.webp"

export const SURVEY_CONFIG_UGC_V2: Array<Screen[]> = [
  [
    {
      type: "ugc_welcome",
      id: "welcome_screen",
      logoColor: "transparent",
      bgColor: "rgb(253, 204, 255)",
      bgImage,
      title: "ugc_v1.welcome.title",
      text: "ugc_v1.welcome.description",
      hideProgressBar: true,
      customProperties: {
        legalText: "ugc_v1.legal",
      },
    },
    {
      type: "text_input",
      text: "ugc_v1.name.title",
      buttonText: "ugc_v1.continue",
      image: coverName,
      id: "input_name",
      bgColor: "rgb(253, 204, 255)",
      logoColor: "transparent",
      bgImage,
      customProperties: {
        fieldName: "name",
      },
    },
  ],
  [
    {
      type: "text_input",
      text: "ugc_v1.country.title",
      buttonText: "ugc_v1.continue",
      image: coverCountry,
      id: "input_country",
      bgColor: "rgb(253, 204, 255)",
      logoColor: "transparent",
      bgImage,
      customProperties: {
        fieldName: "country",
        inputType: "country",
      },
    },
  ],
  [
    {
      type: "text_input",
      text: "ugc_v1.languages.title",
      buttonText: "ugc_v1.continue",
      image: coverLanguages,
      id: "input_languages",
      bgColor: "rgb(253, 204, 255)",
      logoColor: "transparent",
      bgImage,
      customProperties: {
        fieldName: "languages",
        inputType: "languages",
      },
    },
  ],
  [
    {
      type: "text_input",
      text: "ugc_v1.email.title",
      buttonText: "ugc_v1.continue",
      image: coverEmail,
      id: "input_email",
      bgColor: "rgb(253, 204, 255)",
      logoColor: "transparent",
      bgImage,
      customProperties: {
        fieldName: "email",
        inputType: "email",
        submitUrl: "https://pure.app/content/strapi/ugc-responses",
      },
    },
    {
      type: "ugc_success",
      id: "success_screen",
      hideProgressBar: true,
      noMaxHeight: true,
      bgColor: "#000000",
      bgImage: bgImageSuccess,
    },
  ],
]
